import React, { useState } from 'react'
import miniPC from '@/shared/assets/miniPCStand.webp'
import { ReactComponent as UniqDesign } from '@/shared/assets/uniqDesign.svg'
import { ReactComponent as CostEffectiveness } from '@/shared/assets/costEffectiveness.svg'
import { ReactComponent as Performance } from '@/shared/assets/perfromance.svg'
import { ReactComponent as Waterproof } from '@/shared/assets/waterproof.svg'
import { ReactComponent as StarMark } from '@/shared/assets/starMark.svg'
import { ReactComponent as Ornament } from '@/shared/assets/ornament.svg'
import { ReactComponent as LightGlow } from '@/shared/assets/lightGreenGlow.svg'
import { ReactComponent as VioletGlow } from '@/shared/assets/violetGlow.svg'
import { ReactComponent as Triangle } from '@/shared/assets/triangle.svg'
import Modal from '@/shared/ui/Modal/Modal'
import { Configuration } from '../Configuration/Configuration'
import cls from './MiniPCPresentation.module.scss'

export const MiniPCPresentation = () => {
    const [open, setOpen] = useState(false)
    const miniPCFeatures = [
        {
            icon: <UniqDesign className={cls.icon} />,
            title: 'Unique design',
        },
        {
            icon: <CostEffectiveness className={cls.icon} />,
            title: 'Cost-effectiveness',
        },
        {
            icon: <Performance className={cls.icon} />,
            title: 'Performance',
        },
        {
            icon: <Waterproof className={cls.icon} />,
            title: 'Waterproof casing',
        },
    ]
    return (
        <section className={cls.MiniPCPresentation}>
            <div className={cls.topBlock}>
                <LightGlow className={cls.lightGlow} />
                <VioletGlow className={cls.violetGlow} />
                <img
                    src={miniPC}
                    alt="miniPC"
                />
                <Triangle className={cls.triangle} />
                <div className={cls.lines}>
                    <div className={cls.firstLine} />
                    <div className={cls.secondLine} />
                    <div className={cls.thirdLine} />
                </div>
                <Ornament className={cls.ornament} />
                <div className={cls.rightContainer}>
                    <div className={cls.text}>
                        <span>our products</span>
                        <div id="productList">
                            <h1>Box Solution</h1>
                            <p>
                                We combine innovative technology and gaming expertise to create cutting-edge casino
                                solutions. Reliability, scalability, and top-tier gameplay—all in one device.
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={() => setOpen(true)}
                        className={cls.configButton}
                    >
                        <StarMark /> <p>View configuration</p>
                    </button>
                </div>
                <div className={cls.shadow} />
            </div>
            <div className={cls.preferences}>
                {miniPCFeatures.map((feature) => (
                    <div className={cls.preference}>
                        {feature.icon}
                        <p>{feature.title}</p>
                    </div>
                ))}
            </div>
            <Modal
                isOpen={open}
                setOpen={setOpen}
            >
                <Configuration onClick={() => setOpen(false)} />
            </Modal>
        </section>
    )
}
